export const isValidGezinsbondNumber = (value: string | undefined) => {
  if (!value) return false;

  return /^[0-9]{3}-[0-9]{3}-[0-9]{3}$/.test(value);
};
